import { render, staticRenderFns } from "./update.vue?vue&type=template&id=1fb517df&scoped=true"
import script from "./update.vue?vue&type=script&lang=ts"
export * from "./update.vue?vue&type=script&lang=ts"
import style0 from "./update.vue?vue&type=style&index=0&id=1fb517df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb517df",
  null
  
)

export default component.exports